export function getRecommendationKey({
  offerId,
  occupancy,
  checkIn,
  checkOut,
}: {
  offerId?: string
  occupancy?: string
  checkIn?: string
  checkOut?: string
}): string {
  return `${offerId ?? ''}-${occupancy ?? ''}-${checkIn ?? ''}-${checkOut ?? ''}`
}
